/**
 * The text of a spreadsheet download. Kept apart from the DOM click in
 * DataKit so the escaping rules are unit-tested.
 */

/** Excel on Windows reads a CSV without a byte-order mark as the local
 *  code page, so "Priyā" and "Zoë" arrive garbled. */
const BYTE_ORDER_MARK = "\uFEFF";

/** A cell a spreadsheet would run as a formula. Guests type their own
 *  names, notes and group names, so "=HYPERLINK(...)" must stay text. */
const FORMULA_START = /^[=+\-@\t\r]/;

/** A phone number or a signed number: nothing a formula could call or
 *  reference (no letters, no cell references), so it is left exactly as
 *  typed. "+61 412 345 678" is the common case in a guest list, and an
 *  apostrophe in front of it would show in the organiser's sheet. */
const PLAIN_NUMBER = /^[+-][\d\s().-]*$/;

function guardFormula(text: string): string {
  return FORMULA_START.test(text) && !PLAIN_NUMBER.test(text)
    ? `'${text}`
    : text;
}

function csvCell(cell: string | number): string {
  const text = guardFormula(String(cell));
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** Header plus rows as CSV text, byte-order mark first, CRLF line ends. */
export function csvText(
  header: readonly string[],
  rows: readonly (readonly (string | number)[])[],
): string {
  const lines = [header, ...rows].map((row) => row.map(csvCell).join(","));
  return `${BYTE_ORDER_MARK}${lines.join("\r\n")}`;
}
